import { ColorPickerDirective, DialogComponent, SliderDirective, TextDirective } from 'app/components/color-picker/color-picker.directive';
import { ColorPickerService } from 'app/components/color-picker/color-picker.service';
import { CodiceFiscale } from 'app/model/codice_fiscale';
import { Luoghi } from 'app/model/luoghi';

// model
import { Agende } from 'app/model/agende';
import { ImpostazioniGenerali } from 'app/model/impostazioni_generali';
import { Pazienti } from 'app/model/pazienti';
import { SharedUsers } from 'app/model/shared_user';

// component
import { AnagraficaComponent } from 'app/anagrafica/anagrafica';
import { SelezionePeriodoComponent } from 'app/anagrafica/selezione-periodo/periodo';
import { AppComponent } from 'app/app.component';
import { SalaAttesaComponent } from 'app/calendar/sala-attesa/sala_attesa';
import { PaginatorComponent } from 'app/components/paginator/paginator.component';
import { SearchComponent } from 'app/components/search/search.component';
import { TooltipComponent } from 'app/components/tooltip/tooltip';
import { HomeComponent } from 'app/home/home';
import { WelcomeComponent } from 'app/home/welcome/welcome';
import { AlternativaComponent } from 'app/impostazioni_agenda/alternativa/alternativa';
import { NuovaAlternativaComponent } from 'app/impostazioni_agenda/alternativa/nuova/nuova';
import { AmbulatorioComponent } from 'app/impostazioni_agenda/ambulatorio/ambulatorio';
import { ShareComponent } from 'app/impostazioni_agenda/condividi/condividi';
import { OrarioComponent } from 'app/impostazioni_agenda/generali/generali';
import { LoginComponent } from 'app/login/login';
import { NavbarComponent } from 'app/navbar/navbar';
import { ColorsComponent } from 'app/opzioni/colori/colori';
import { PasswordComponent } from 'app/opzioni/password/password';
import { RubricaComponent } from 'app/rubrica/rubrica';

// modal dialog
import { ConflictComponent } from 'app/calendar/conflict/conflict';
import { NewEventComponent } from 'app/calendar/newEvent/newEvent';
import { AlertDialogComponent } from 'app/components/dialog/dialog';
import { ErrorComponent } from 'app/components/error/error';
import { ConfirmationComponent } from 'app/home/sidebar/confirmation/confirmation';
import { NewAgendaComponent } from 'app/home/sidebar/newAgenda/new_agenda';
import { SidebarComponent } from 'app/home/sidebar/sidebar';
import { SettingsComponent } from 'app/impostazioni_agenda/impostazioni_agenda';
import { OptionsComponent } from 'app/opzioni/opzioni';
import { ChangeComponent } from 'app/rubrica/changeCategory/change';

// module
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { AppRoutingModule } from 'app/app-routing.module';

// angular
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FullCalendarComponent } from 'app/calendar/full-calendar/fullcalendar.component';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NewPatientComponent } from 'app/anagrafica/newPatient/newPatient';
import { BusinessDayComponent } from 'app/calendar/business-day/business-day.component';
import { CalendarStyleComponent, SettimanaStyleComponent } from 'app/calendar/calendar-style/calendar-style.component';
import { EditInputComponent } from 'app/components/edit_input/edit_input.component';
import { StyleComponent } from 'app/components/style/style.component';
import { Config } from 'app/config.const';
import { Contatti, ContattiUtenti } from 'app/model/contatti';
import { ItalianDateFormatter } from 'app/model/dateFormatAdapter';
import { NewContactComponent } from 'app/rubrica/newContact/newContact';

import { UserCalendarComponent } from 'app/calendar/user-calendar/usercalendar.component';

import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/observable/concat';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/toPromise';
import { TokenAuthService } from './auth/token-auth.service';
import { BlankComponent } from './home/blank/blank.component';

import { CookieTokenStore, RESTConfig, RestModule, TokenStore } from './angular-rest';
import { NewEventSpecialComponent } from "./calendar/newEventSpecial/newEventSpecial";
import { SctAgendaInterceptor } from './sct-agenda.interceptor';

export function identity<T>(val: T) {
	return val;
};

@NgModule({
	declarations: [
		SidebarComponent,
		DialogComponent,
		TextDirective,
		SliderDirective,
		ColorPickerDirective,
		NavbarComponent,
		AppComponent,
		LoginComponent,
		HomeComponent,
		WelcomeComponent,
		ConflictComponent,
		ErrorComponent,
		AlertDialogComponent,
		ConfirmationComponent,
		FullCalendarComponent,
		TooltipComponent,
		NewAgendaComponent,
		NewEventComponent,
		NewContactComponent,
		NewPatientComponent,
		ChangeComponent,
		RubricaComponent,
		AnagraficaComponent,
		SalaAttesaComponent,
		SettingsComponent,
		ShareComponent,
		OrarioComponent,
		AmbulatorioComponent,
		AlternativaComponent,
		NuovaAlternativaComponent,
		SelezionePeriodoComponent,
		OptionsComponent,
		ColorsComponent,
		PasswordComponent,
		EditInputComponent,
		PaginatorComponent,
		SearchComponent,
		StyleComponent,
		CalendarStyleComponent,
		SettimanaStyleComponent,
		BusinessDayComponent,
		UserCalendarComponent,
		BlankComponent,

		NewEventSpecialComponent,
	],
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
		HttpClientModule,
		MatGridListModule,
		MatCardModule,
		AppRoutingModule,
		RestModule,
		NgbModule.forRoot()
	],
	providers: [
		ColorPickerService,
		SharedUsers,
		ImpostazioniGenerali,
		CodiceFiscale,
		Luoghi,
		Agende,
		Contatti,
		Pazienti,
		ContattiUtenti,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TokenAuthService,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: SctAgendaInterceptor,
			multi: true
		},
		{
			provide: RESTConfig,
			useValue: Config
		},
		{
			provide: TokenStore,
			useClass: CookieTokenStore
		},
		{
			provide: NgbDateParserFormatter,
			useClass: ItalianDateFormatter
		}
	],
	bootstrap: [AppComponent],
	entryComponents: [
		DialogComponent,
		TooltipComponent,
		SettingsComponent,
		ConflictComponent,
		ErrorComponent,
		AlertDialogComponent,
		NewAgendaComponent,
		NewEventComponent,
		NewContactComponent,
		NewPatientComponent,
		ChangeComponent,
		ConfirmationComponent,
		NuovaAlternativaComponent,
		SelezionePeriodoComponent,
		SalaAttesaComponent,
		OptionsComponent,
		ColorsComponent,
		PasswordComponent,
		NewEventSpecialComponent
	]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts